import { render, staticRenderFns } from "./_incomes.vue?vue&type=template&id=5d1dc205&scoped=true&"
import script from "./_incomes.vue?vue&type=script&lang=js&"
export * from "./_incomes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d1dc205",
  null
  
)

export default component.exports